module.exports = __webpack_public_path__ + "img/flexsale_digi_wireframe.c55aafb1.png";